// resources
import * as BBApi from '..';
const rootUrl: string = BBApi.host + '/red-cross/snaksammen';

export type QueryResult = {
	records: Record<string, any>[];
	matches: number;
};

export async function queryVolunteers(queryValues: Record<string, any>): Promise<QueryResult> {
	const url: URL = new URL(rootUrl + '/volunteers');
	url.searchParams.append('offset', queryValues.offset ?? String(0));
	// url.searchParams.append('amount', queryValues.amount);
	if (queryValues.search !== '') url.searchParams.append('search', `%${queryValues.search}%`);

	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const { records, matches }: QueryResult = await response.json();
	return { records, matches };
}

export async function createVolunteer(volunteer: Record<string, any>): Promise<void> {
	const host: string = String(process.env.REACT_APP_BOBLBERG_API_HOST);
	const data = { origin: 'Røde Kors/ SnakSammen', password: '1234', country: 'Denmark',  ...volunteer }

	const userResponse: Response = await fetch(host + 'users/signup', {
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(data),
		method: 'POST',
	});

	const json = await userResponse.json();
	if (json?.error !== undefined) throw new Error(json.error);

	const body = { id: json.user.id, juniorAccess: volunteer.juniorAccess };
	const volunteerResponse: Response = await BBApi.post(rootUrl + '/volunteers', body);

	if (volunteerResponse.ok === false) {
		const message: string = await volunteerResponse.text();
		throw new Error(message);
	}
}

export async function linkVolunteer(id: number, juniorAccess: boolean): Promise<void> {
	const response: Response = await BBApi.post(rootUrl + '/volunteers', { id, juniorAccess });

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}
}

export async function removeAccess(userId: number): Promise<void> {
	const response: Response = await BBApi.del(rootUrl + `/volunteers/${userId}`);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}
}

export async function queryUsers(email: string): Promise<Record<string, any>[]> {
	const url: URL = new URL(rootUrl + '/users');
	url.searchParams.append('email', email + '%' ?? '');
	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const users: Record<string, any>[] = await response.json();
	return users;
}

export async function querySessions(queryValues: Record<string, any>): Promise<QueryResult> {
	const url: URL = new URL(rootUrl + '/sessions');

	url.searchParams.append('amount', queryValues.amount);
	url.searchParams.append('offset', queryValues.offset ?? String(0));
	if (queryValues.search !== '') url.searchParams.append('search', `%${queryValues.search}%`);

	if (queryValues.date !== null) {
		const [dateFrom, dateTo] = queryValues.date;
		if (dateFrom !== null) url.searchParams.append('dateFrom', dateFrom.format('YYYY-MM-DD'));
		if (dateTo !== null) url.searchParams.append('dateUntil', dateTo.format('YYYY-MM-DD'));
	}

	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const { records, matches }: QueryResult = await response.json();
	return { records, matches };
}
